import { FilterTwoTone } from '@ant-design/icons';
import { Button, Checkbox, Popover } from 'antd';
import { CheckboxGroupProps } from 'antd/lib/checkbox';
import { FC, useMemo } from 'react';
import { omit } from 'lodash';
import { CareNoteTagEnum } from '../../../../uc-api-sdk';
import { CareNoteTagEnumComponent } from '../../../../enumComponent/CareNoteTagEnumComponent/CareNoteTagEnumComponent';

const VALID_CARE_NOTE_TAGS = omit(CareNoteTagEnum, [CareNoteTagEnum.MONTHLY_REVIEW]);

export interface CareNoteTagFilterComponentProps {
  onChange: CheckboxGroupProps['onChange'];
}

export const CareNoteTagFilterComponent: FC<CareNoteTagFilterComponentProps> = ({
  onChange,
}) => {
  const options = useMemo(() => (
    Object.keys(VALID_CARE_NOTE_TAGS).map((k) => ({
      label: <CareNoteTagEnumComponent value={k as CareNoteTagEnum} />,
      value: k
    }))
  ), []);

  return (
    <Popover
      trigger="click"
      content={(
        <Checkbox.Group
          className="flex fd-c"
          options={options}
          onChange={onChange}
        />
      )}
      placement="bottom"
    >
      <Button type="link">
        <FilterTwoTone />
        {' '}
        Filter
      </Button>
    </Popover>
  );
};
